
import http from '@utils/http';

export function bookType(params) {
  return http.post('/api/book/bookType/list', params);
}

export function booksList(params) {
  return http.post('/api/book/h5/book/pageList', params);
}

export function countStatistics(params) {
  return http.post('/api/book/h5/book/countStatistics', params);
}

export function doPraise(params) {
  return http.post('/api/book/h5/book/doPraise', params);
}

export function doTrample(params) {
  return http.post('/api/book/h5/book/doTrample', params);
}

export function borrowBook(params) {
  return http.post('/api/book/h5/book/borrowBook', params);
}

export function returnBook(params) {
  return http.post('/api/book/h5/book/returnBook', params);
}

export function addComment(params) {
  return http.post('/api/book/h5/book/addComment', params);
}
